import { useCallback, useMemo, useRef } from 'react';
import { formatNumber } from '@agro1desenvolvimento/utils-js';
import { OverlayPanel } from 'primereact/overlaypanel';
import { Button } from 'primereact/button';
import { RecomendacaoSemeaduraStatusGleba } from '../../@types';

type SituacaoFieldTooltipProps = {
  glebas: RecomendacaoSemeaduraStatusGleba[];
};

const SituacaoFieldTooltip = ({ glebas }: SituacaoFieldTooltipProps) => {
  const ref = useRef<OverlayPanel | null>(null);
  const formatArea = useCallback(
    (area: number) => formatNumber(area, { maximumFractionDigits: 1 }),
    [],
  );

  const checarAuditoria = useMemo(() => !glebas.length, [glebas]);

  return (
    <>
      <Button
        icon="pi pi-info-circle"
        rounded
        severity="secondary"
        className="button-info"
        size="small"
        onClick={(e) => ref.current?.toggle(e)}
      />
      <OverlayPanel
        id="overlay-panel-info"
        className="overlay-panel-info"
        ref={ref}
      >
        {checarAuditoria ? (
          <span className="overlay-panel-info-text">
            Não foram identificados plantios aprovados, verifique a fila para
            auditoria.
          </span>
        ) : (
          <>
            <p className="overlay-panel-info-text">Plantios já realizados</p>
            <table className="percentual-table">
              <thead>
                <tr>
                  <td className="overlay-panel-info-text">Talhão</td>
                  <td className="center overlay-panel-info-text">
                    Recomendado (ha)
                  </td>
                  <td className="center overlay-panel-info-text">
                    Realizado (ha)
                  </td>
                </tr>
              </thead>
              <tbody>
                {glebas.map((statusGleba) => (
                  <tr key={statusGleba.gleba.id}>
                    <td className="overlay-panel-info-text">
                      {statusGleba.gleba.descricao}
                    </td>
                    <td className="center overlay-panel-info-text">
                      {formatArea(statusGleba.areaRecomendada)}
                    </td>
                    <td className="center overlay-panel-info-text">
                      {formatArea(statusGleba.areaAplicada)}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </OverlayPanel>
    </>
  );
};

export default SituacaoFieldTooltip;
